import { SPONSOR_LOCALES, type SponsorLocale } from '@/lib/contract'

/* Spec PWA-001 — resolucao de idioma (FR-036).
   Funcoes puras: a leitura do dispositivo/storage fica em quem chama (platform layer, T056). */

export const DEFAULT_LOCALE: SponsorLocale = 'pt-BR'
export const LANGUAGE_STORAGE_KEY = 'gpd-language'

export function isSponsorLocale(value: unknown): value is SponsorLocale {
    return typeof value === 'string' && (SPONSOR_LOCALES as readonly string[]).includes(value)
}

/* Mapeia uma lista de idiomas do dispositivo (ex.: navigator.languages) para um idioma suportado.
   Casa exato (pt-BR) e depois por idioma base (pt-PT → pt-BR, en-GB → en-US). Sem casamento ⇒ pt-BR. */
export function resolveDeviceLocale(candidates: readonly string[]): SponsorLocale {
    for (const raw of candidates) {
        const candidate = raw.trim()
        const exact = SPONSOR_LOCALES.find(l => l.toLowerCase() === candidate.toLowerCase())
        if (exact) return exact
        const base = candidate.split('-')[0]?.toLowerCase()
        const byBase = SPONSOR_LOCALES.find(l => l.split('-')[0]!.toLowerCase() === base)
        if (byBase) return byBase
    }
    return DEFAULT_LOCALE
}

/* Preferencia salva no aparelho vence o idioma do dispositivo. Valor invalido e ignorado. */
export function resolveInitialLocale(stored: string | null, deviceCandidates: readonly string[]): SponsorLocale {
    return isSponsorLocale(stored) ? stored : resolveDeviceLocale(deviceCandidates)
}
